import React, { useState, useEffect } from 'react';
import { BellOutlined, CloseOutlined } from '@ant-design/icons';
import './NotificationModal.css';

const NotificationModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);

  // Mock notifications - replace with your actual data
  useEffect(() => {
    setNotifications([
      {
        id: 1,
        title: 'New class available',
        message: 'Your instructor has added new materials to "Advanced React"',
        time: '2 hours ago',
        read: false
      },
    ]);
  }, []);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const markAsRead = (id) => {
    setNotifications(notifications.map(notification => 
      notification.id === id ? { ...notification, read: true } : notification
    ));
  };

  return (
    <div className="notification-container">
      <button className="notification-bell" onClick={toggleModal}>
        <BellOutlined />
        {notifications.some(n => !n.read) && (
          <span className="notification-badge"></span>
        )}
      </button>

      <div className={`notification-modal ${isOpen ? 'open' : ''}`}>
        <div className="notification-header">
          <h3>Notifications</h3>
          <button className="close-btn" onClick={toggleModal}>
            <CloseOutlined />
          </button>
        </div>

        <div className="notification-list">
          {notifications.length > 0 ? (
            notifications.map(notification => (
              <div 
                key={notification.id} 
                className={`notification-item ${notification.read ? '' : 'unread'}`}
                onClick={() => markAsRead(notification.id)}
              >
                <div className="notification-dot"></div>
                <div className="notification-content">
                  <h4>{notification.title}</h4>
                  <p>{notification.message}</p>
                  <span className="notification-time">{notification.time}</span>
                </div>
              </div>
            ))
          ) : (
            <div className="empty-notifications">
              <p>No new notifications</p>
            </div>
          )}
        </div>

        <div className="notification-footer">
          <button className="mark-all-read">
            Mark all as read
          </button>
        </div>
      </div>

      {/* Overlay when modal is open */}
      {isOpen && (
        <div className="notification-overlay" onClick={toggleModal}></div>
      )}
    </div>
  );
};

export default NotificationModal;